import { render } from "./PrjPersonFinancial.vue?vue&type=template&id=789be8ca&scoped=true"
import script from "./PrjPersonFinancial.vue?vue&type=script&lang=js"
export * from "./PrjPersonFinancial.vue?vue&type=script&lang=js"

import "./PrjPersonFinancial.vue?vue&type=style&index=0&id=789be8ca&lang=less&scoped=true"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-789be8ca"]])

export default __exports__